import React from "react";
import http from "../modules/api";

import DatePicker from "react-datepicker";
import { ko } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";

import TextInput from "../modules/common/TextInput";
import SelectBoxV2 from "../modules/common/SelectBoxV2";
import Button from "../modules/common/Button";

const LANGUAGE_OPTIONS = [
  { text: "전체 언어", value: "" },
  { text: "한국어", value: "KO" },
  { text: "영어", value: "EN" },
  { text: "일본어", value: "JA" },
];

const LEARNING_OPTIONS = [
  { text: "전체 학습 설정", value: "" },
  { text: "학습 사용", value: "Y" },
  { text: "학습 미사용", value: "N" },
];

const languageList = [
  { name: '한국어', code: 'ko' }, { name: '영어', code: 'en' },
  { name: '독일어', code: 'de' }, { name: '중국어(간체)', code: 'zh-cn' },
  { name: '중국어(번체)', code: 'zh-tw' }, { name: '일본어', code: 'ja' },
  { name: '베트남어', code: 'vi' }, { name: '프랑스어', code: 'fr' },
  { name: '스페인어', code: 'es' }, { name: '힌디어', code: 'hi' },
  { name: '아랍어', code: 'ar' }, { name: '벵골어', code: 'bn' },
  { name: '러시아어', code: 'ru' }, { name: '포르투갈어', code: 'pt' }
];

export default class InstagramCopywriterSettingList extends React.Component {
  static defaultProps = {
    pageSizes: [
      { value: 20, text: "20개" },
      { value: 50, text: "50개" },
      { value: 100, text: "100개" },
    ],
  };

  constructor(props) {
    super(props);
    this.state = {
      rows: Array.isArray(props.rows) && props.rows.length ? props.rows : [],

      q: "",
      language_code: "",
      is_data_learning_on: "",
      startDate: null,
      endDate: null,

      page: 1,
      pageSize: 20,
      sortKey: "icp.reg_date",
      sortDir: "desc",
      total: 0,
      dateType: "all",
    };
  }

  componentDidMount() {
    this.fetchListFromApi();
  }

  formatDate = (date) => {
    if (!date) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  fetchListFromApi = async () => {
    const {
      q,
      language_code,
      is_data_learning_on,
      startDate,
      endDate,
      page,
      pageSize,
      sortKey,
      sortDir,
    } = this.state;

    try {
      const resp = await http.get("/rest/shop/instagram/copywriter/preset/list", {
        params: {
          q: q || "",
          language_code: language_code || "",
          is_data_learning_on: is_data_learning_on || "",
          sort_by: sortKey || "icp.reg_date",
          sort_dir: (sortDir || "desc").toUpperCase(),
          start: (page - 1) * pageSize,
          row_cnt: pageSize,
          start_date: startDate ? this.formatDate(startDate) : null,
          end_date: endDate ? this.formatDate(endDate) : null,
        },
      });

      const { total, list } = resp.data.result || resp.data;

      const rows = (list || []).map((m) => {
        return {
          id: String(m.preset_seq),
          preset_title: m.preset_title || "-",
          industry: m.industry || "-",
          target: m.target || "-",
          language_code: m.language_code || "-",
          objective: m.objective || "-",
          extra_prompt: m.extra_prompt || "",
          is_data_learning_on: m.is_data_learning_on || "N",
          learning_data_type: m.learning_data_type || "-",
          call_to_action_position: m.call_to_action_position || "-",
          call_to_action_text: m.call_to_action_text || "-",
          use_basic_voice: m.use_basic_voice,
          use_myfeed_voice: m.use_myfeed_voice,
          use_custom_voice: m.use_custom_voice,
          basic_voice_index: m.basic_voice_index,
          custom_voice_index: m.custom_voice_index,
          reg_date: m.reg_date,
          reg_date_format: m.reg_date_format || m.reg_date || "-",
        };
      });

      this.setState({
        rows,
        total: total || 0,
      });
    } catch (err) {
      console.error("카피라이터 프리셋 목록 조회 실패", err);
    }
  };

  fmtNumber(n) {
    return n === null || n === undefined ? "-" : Number(n).toLocaleString();
  }

  changeSort = (key) => {
    this.setState(
      (prev) =>
        prev.sortKey === key
          ? { sortDir: prev.sortDir === "asc" ? "desc" : "asc" }
          : { sortKey: key, sortDir: "desc" },
      this.fetchListFromApi
    );
  };

  handleInput = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value, page: 1 });
  };

  handleSelectBox = (name) => (text, value) => {
    this.handleInput({ target: { name, value } });
  };

  setQuickRange = (type) => {
    const today = new Date();

    if (type === "today") {
      this.setState({ startDate: today, endDate: today, page: 1 }, this.fetchListFromApi);
    } else if (type === "week") {
      const day = today.getDay();
      const diff = day === 0 ? 6 : day - 1;
      const monday = new Date(today);
      monday.setDate(today.getDate() - diff);
      const sunday = new Date(monday);
      sunday.setDate(monday.getDate() + 6);
      this.setState({ startDate: monday, endDate: sunday, page: 1 }, this.fetchListFromApi);
    } else if (type === "month") {
      const first = new Date(today.getFullYear(), today.getMonth(), 1);
      const last = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      this.setState({ startDate: first, endDate: last, page: 1 }, this.fetchListFromApi);
    } else {
      this.setState({ startDate: null, endDate: null, page: 1 }, this.fetchListFromApi);
    }

    this.setState({ dateType: type });
  };

  goPage = (p) => {
    this.setState({ page: p }, this.fetchListFromApi);
  };

  changePageSize = (e) => {
    this.setState({ pageSize: Number(e.target.value), page: 1 }, this.fetchListFromApi);
  };

  renderSortHead(label, key, align = "left", width = "auto") {
    return (
      <th
        onClick={() => this.changeSort(key)}
        style={{ width, cursor: "pointer", textAlign: align }}
        title="정렬"
      >
        {label}
      </th>
    );
  }

  renderVoiceBadges = (row) => {
    const items = [];

    if (row.use_basic_voice == 1 || row.use_basic_voice === true || row.use_basic_voice === "Y") {
      items.push(<span key="basic" className="badge badge-auto" style={{ marginRight: 4 }}>AI 브랜드 보이스</span>);
    }

    if (row.use_myfeed_voice == 1 || row.use_myfeed_voice === true || row.use_myfeed_voice === "Y") {
      items.push(<span key="myfeed" className="badge badge-scheduled" style={{ marginRight: 4 }}>내 기존 피드</span>);
    }

    if (row.use_custom_voice == 1 || row.use_custom_voice === true || row.use_custom_voice === "Y") {
      items.push(<span key="custom" className="badge badge-manual">커스텀 뱅크</span>);
    }

    if (items.length === 0) {
      return <span className="badge badge-failed">선택 없음</span>;
    }

    return items;
  };

  renderLearningBadge = (value) => {
    if (value === "Y" || value === 1 || value === true) {
      return <span className="badge badge-auto">학습 사용</span>;
    }
    return <span className="badge badge-manual">학습 미사용</span>;
  };

  render() {
    const { pageSizes } = this.props;
    const {
      q,
      language_code,
      is_data_learning_on,
      startDate,
      endDate,
      page,
      pageSize,
      dateType,
      rows,
      total,
    } = this.state;

    const totalPages = Math.max(1, Math.ceil((total || 0) / pageSize));

    return (
      <>
      <style>{`
        /* =========================
        게시물 관리(Posts) 전용 CSS
        원본 instagram_automation_settings_14.html 기반
        ========================= */
        .instagram-copywriter-list {
            --ig-border: #dbdbdb;
            --ig-muted: #8e8e8e;
            --ig-bg: #fff;
            --ig-text: #262626;
            padding-bottom: 18px;

            .common_button {
                border-radius: 6px !important;
                font-weight: 400 !important;
            }
            .common_button::after {
                border-radius: 6px !important;
            }

            .react-datepicker-wrapper {
                margin-bottom: 0px !important;
            }

            .pagination {
                max-width: 100% !important;
            }

            #pageSizeSelect {
                background-color: white !important;
            }

            .data-table {
                /* overflow: visible !important; */
            }

            .react-datepicker-wrapper {
                margin-bottom: 0 !important;
            }

            /* 이미지 썸네일 & 호버 프리뷰 */
            .img-thumbnail {
                position: relative;
                display: inline-block;
                cursor: pointer;
            }
            .img-preview {
                position: absolute;
                z-index: 999;
                display: none;
                left: 60px;
                top: 50%;
                transform: translateY(-50%);
                background: #fff;
                border-radius: 12px;
                box-shadow: 0 10px 40px rgba(0,0,0,0.3);
                overflow: hidden;
                width: 320px;
            }
            .img-thumbnail:hover .img-preview { display: block; }
            .img-preview-content {
                width: 320px;
                height: 320px;
                background: #f0f0f0;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 16px;
                color: #8e8e8e;
                position: relative;
            }
            .img-preview-info {
                padding: 12px;
                background: #fff;
                border-top: 1px solid #efefef;
            }
            /* 캐러셀 점 */
            .carousel-dots {
                position: absolute;
                bottom: 10px;
                left: 50%;
                transform: translateX(-50%);
                display: flex;
                gap: 4px;
                padding: 4px 8px;
                background: rgba(0,0,0,0.5);
                border-radius: 10px;
            }
            .dot { width: 6px; height: 6px; background: rgba(255,255,255,0.5); border-radius: 50%; }
            .dot.active { background: #fff; }

            /* 테이블 박스 */
            .data-table {
                width: 100%;
                background: #fff;
                border-radius: 8px 8px 0px 0px;
                border: 1px solid #dbdbdb;
                /* overflow: visible; */
                overflow: auto;
            }
            .data-table table {
                width: 100%;
                border-collapse: collapse;
            }
            .data-table thead {
                background: #fafafa;
                border-bottom: 2px solid #dbdbdb;
            }
            .data-table th {
                padding: 15px;
                text-align: left;
                font-weight: 600;
                color: #262626;
                font-size: 13px;
                white-space: nowrap;
            }
            .data-table tbody tr {
                border-bottom: 1px solid #efefef;
                transition: background 0.2s;
            }
            .data-table tbody tr:hover { background: #fafafa; }
            .data-table td {
                padding: 15px;
                font-size: 14px;
                vertical-align: middle;
            }

            /* 상태/유형 배지 */
            .badge {
                display: inline-block;
                padding: 4px 8px;
                border-radius: 4px;
                font-size: 11px;
                font-weight: 600;
            }
            .badge-auto     { background: #e3f2fd; color: #1976d2; }
            .badge-manual   { background: #f3e5f5; color: #7b1fa2; }
            .badge-published{ background: #e8f5e9; color: #2e7d32; }
            .badge-scheduled{ background: #e3f2fd; color: #1976d2; }
            .badge-draft    { background: #fff3e0; color: #f57c00; }
            .badge-failed   { background: #ffebee; color: #ed4956; }

            /* 필터 영역 */
            .filter-section {
                background: #fff;
                border-radius: 8px;
                border: 1px solid #dbdbdb;
                padding: 20px;
                margin-bottom: 20px;
            }
            .filter-row {
                display: flex;
                gap: 15px;
                align-items: center;
                margin-bottom: 15px;
                flex-wrap : wrap;
            }
            .filter-row:last-child { margin-bottom: 0; }
            .quick-filters { display: flex; gap: 10px; }
            .quick-filter-btn {
                padding: 5px 12px;
                background: #f0f0f0;
                border: none;
                border-radius: 20px;
                font-size: 12px;
                cursor: pointer;
                transition: all 0.2s;
            }
            .quick-filter-btn:hover { background: #e0e0e0; }
            .quick-filter-btn.active { background: #262626; color: #fff; }

            /* 페이지네이션 */
            .pagination {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 20px;
                background: #fafafa;
                border: 1px solid #dbdbdb;
                border-top: none;
                border-radius: 0 0 8px 8px;
            }
            .pagination-controls {
                display: flex;
                gap: 5px;
                align-items: center;
                margin: auto;
            }
            .page-btn {
                padding: 5px 12px;
                border: 1px solid #dbdbdb;
                background: #fff;
                border-radius: 4px;
                cursor: pointer;
                font-size: 14px;
                transition: all 0.2s;
            }
            .page-btn:hover { background: #fafafa; }
            .page-btn.active {
                background: #262626;
                color: #fff;
                border-color: #262626;
            }

            /* 공통 폼 컨트롤(원본과 매칭) */
            .form-control {
                width: 100%;
                padding: 10px;
                border: 1px solid #dbdbdb;
                border-radius: 6px;
                font-size: 14px;
                transition: all 0.2s;
            }
            .form-control:focus {
                outline: none;
                border-color: #0095f6;
            }

            /* React-DatePicker를 form-control 룩에 맞추기 (우리가 추가) */
            .react-datepicker__input-container input.form-control {
                height: 36px; /* 원본 input 높이에 맞춤 */
            }
            .react-datepicker-popper { z-index: 50; }

            /* 원래 .img-preview는 숨겨두고, 포털로 복제해서 띄울 예정 */
            .img-preview { display: none; }

            /* 포털에 들어갈 프리뷰 박스 */
            .preview-box {
                position: fixed;              /* viewport 기준으로 배치 */
                max-width: 380px;
                border-radius: 8px;
                box-shadow: 0 8px 24px rgba(0,0,0,.2);
                background: #fff;
                overflow: hidden;
                z-index: 10000;
            }

            .preview-box .img-preview-content { 
            /* 기존 스타일 재사용 가능 */
            }

            .preview-box .img-preview-info { 
                padding: 10px 12px;
            }

            /* 프리뷰의 '히트박스'가 되는 바깥 박스: overflow: visible 이어야 함 */
            .preview-box {
                position: fixed;
                z-index: 10000;
                overflow: visible;              /* 중요: 히트박스 확장 위해 */
            }

            /* 실제 보이는 표면(모서리/그림자/배경)은 안쪽에 둠 */
            .preview-surface {
                width: 380px;
                border-radius: 8px;
                box-shadow: 0 8px 24px rgba(0,0,0,.2);
                background: #fff;
                overflow: hidden;               /* 표면만 잘라냄 */
            }

            .data-table table th:nth-child(1)
            , .data-table table td:nth-child(1) {
              padding-left: 20px !important;
            }

            @media screen and (max-width: 420px) {
                .robomd_date_picker {
                    flex: none !important;
                    width: 100%;
                }
                .date_picker_wrapper {
                    flex: 1px !important;
                } 
                .robomd_date_picker input.form-control {
                    width: 100% !important;
                }
            }
            @media screen and (max-width: 800px) {
                .pagination-cnt-controls {
                    top: 65px !important;
                }
                .pagination-controls {
                    padding-bottom: 40px !important;
                }
                .pagination {
                    height: 120px !important;
                }
            }
        }

        /* 히트박스 확장 (투명) */
        .instagram-copywriter-list.preview-box::before {
            content: "";
            position: absolute;
            inset: -10px;
            display: block;              /* ★ 꼭 넣어주기 */
            /* background: rgba(255,0,0,.2); */
            z-index: -1;                 /* 필요 시 조정 */
        }
      `}
      </style>
      <div
        id="page-wrapper"
        className="container eventFormPromotion instagram-copywriter-list"
        style={{ backgroundColor: "#fafaf", minHeight: "100%" }}
      >
        <div className="page-section active">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
            <h1 style={{ fontSize: 24, fontWeight: 600 }}>AI 카피라이터 목록</h1>
            <Button
              type={"hover_mint"}
              width={"165px"}
              height={"38px"}
              fontSize={"1rem"}
              onClick={() => {
                if (window.location.pathname == "/shop/genAi/CopywriterSettingList") {
                  window.location.href = "/shop/genAi/CopywriterSetting";
                }
                else {
                  window.location.href = "/shop/instagram/InstagramCopywriterSetting";
                }
              }}
            >
              ＋ 새 카피라이터 설정
            </Button>
          </div>

          <div className="filter-section">
            <div className="filter-row">
              <div style={{ flex: 1.4 }}>
                <TextInput
                  type="text"
                  id="search_q"
                  placeholder="설정 제목 검색"
                  value={q}
                  onChange={(e, value) => this.setState({ q: value })}
                  width="100%"
                  height="36px"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      this.setState({ page: 1 }, this.fetchListFromApi);
                    }
                  }}
                />
              </div>

              <div style={{ flex: 1 }}>
                <SelectBoxV2
                  id="languageSelect"
                  className="form-control"
                  pageWrapperName="common-page-wrapper"
                  width="100%"
                  height="36px"
                  padding="6px 30px 6px 10px"
                  list={LANGUAGE_OPTIONS}
                  optionTexttName="text"
                  optionValuetName="value"
                  selectedValue={language_code}
                  placeHolder="전체 언어"
                  onClickOption={this.handleSelectBox("language_code")}
                  tabIndex={0}
                />
              </div>

              <div style={{ flex: 1 }}>
                <SelectBoxV2
                  id="learningSelect"
                  className="form-control"
                  pageWrapperName="common-page-wrapper"
                  width="100%"
                  height="36px"
                  padding="6px 30px 6px 10px"
                  list={LEARNING_OPTIONS}
                  optionTexttName="text"
                  optionValuetName="value"
                  selectedValue={is_data_learning_on}
                  placeHolder="전체 학습 설정"
                  onClickOption={this.handleSelectBox("is_data_learning_on")}
                  tabIndex={0}
                />
              </div>

              <div
                className="robomd_date_picker flexBox"
                style={{ display: "flex", gap: 15, alignItems: "center", flexWrap: "nowrap", flex: 1.8 }}
              >
                <div style={{ flex: 1 }}>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => this.setState({ startDate: date, page: 1 })}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    maxDate={endDate || undefined}
                    dateFormat="yyyy.MM.dd"
                    locale={ko}
                    isClearable
                    placeholderText="시작일"
                    customInput={<input className="form-control" style={{ width: "100%" }} />}
                  />
                </div>
                <span style={{ color: "#8e8e8e" }}>~</span>
                <div style={{ flex: 1 }}>
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => this.setState({ endDate: date, page: 1 })}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate || undefined}
                    dateFormat="yyyy.MM.dd"
                    locale={ko}
                    isClearable
                    placeholderText="종료일"
                    customInput={<input className="form-control" style={{ width: "100%" }} />}
                  />
                </div>
              </div>

              <button
                className="btn btn-secondary"
                type="button"
                onClick={() => this.setState({ page: 1 }, this.fetchListFromApi)}
              >
                필터 적용
              </button>
            </div>

            <div className="filter-row">
              <div className="quick-filters">
                <button className={"quick-filter-btn" + (!dateType || dateType === "all" ? " active" : "")} onClick={() => this.setQuickRange("all")}>전체</button>
                <button className={"quick-filter-btn" + (dateType === "today" ? " active" : "")} onClick={() => this.setQuickRange("today")}>오늘</button>
                <button className={"quick-filter-btn" + (dateType === "week" ? " active" : "")} onClick={() => this.setQuickRange("week")}>이번 주</button>
                <button className={"quick-filter-btn" + (dateType === "month" ? " active" : "")} onClick={() => this.setQuickRange("month")}>이번 달</button>
              </div>
              <span style={{ marginLeft: "auto", fontSize: 14, color: "#8e8e8e" }}>
                총 {this.fmtNumber(total)}개
              </span>
            </div>
          </div>

          <div className="data-table">
            <table>
              <thead>
                <tr>
                  {this.renderSortHead("설정 제목", "icp.preset_title", "left", 180)}
                  <th style={{ width: 110, textAlign: "center" }}>업종</th>
                  <th style={{ width: 110, textAlign: "center" }}>타겟</th>
                  <th style={{ width: 90, textAlign: "center" }}>언어</th>
                  <th style={{ width: 240, textAlign: "center" }}>브랜드 보이스</th>
                  <th style={{ width: 120, textAlign: "center" }}>학습 설정</th>
                  <th style={{ width: 130, textAlign: "center" }}>CTA 위치</th>
                  {this.renderSortHead("등록일", "icp.reg_date", "center", 150)}
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan={8} style={{ textAlign: "center", padding: 40, color: "#8e8e8e" }}>
                      조건에 맞는 카피라이터 설정이 없습니다.
                    </td>
                  </tr>
                ) : (
                  rows.map((row) => {
                    return (
                      <tr
                        key={row.id}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (window.location.pathname == "/shop/genAi/CopywriterSettingList") {
                            window.location.href = `/shop/genAi/CopywriterSetting?preset_seq=${row.id}`;
                          } else {
                            window.location.href = `/shop/instagram/InstagramCopywriterSetting?preset_seq=${row.id}`;
                          }
                        }}
                      >
                        <td>
                          <div style={{ fontWeight: 500, textAlign: "left" }}>{row.preset_title}</div>
                        </td>
                        <td style={{ textAlign: "center" }}>{row.industry}</td>
                        <td style={{ textAlign: "center" }}>{row.target}</td>
                        <td style={{ textAlign: "center" }}>
                          {languageList.find(lang => lang.code === row.language_code)?.name || row.language_code}
                        </td>
                        <td style={{ textAlign: "center" }}>{this.renderVoiceBadges(row)}</td>
                        <td style={{ textAlign: "center" }}>{this.renderLearningBadge(row.is_data_learning_on)}</td>
                        <td style={{ textAlign: "center" }}>
                          {row.call_to_action_position
                          ? row.call_to_action_position == "top" 
                            ? "상단 고정 추가" 
                            : row.call_to_action_position == "bottom" 
                                ? "하단 고정 추가" 
                                : "-"
                          : "-"}
                        </td>
                        <td style={{ textAlign: "center", fontSize: 13 }}>
                          {row.reg_date_format || "-"}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          <div className="pagination" style={{ position: "relative", overflow: "visible" }}>
            <div className="pagination-controls">
              <button className="page-btn" disabled={page <= 1} onClick={() => this.goPage(page - 1)}>◀</button>
              {Array.from({ length: Math.min(5, totalPages) }).map((_, i) => {
                const half = Math.floor(5 / 2);
                let start = Math.max(1, page - half);
                let end = Math.min(totalPages, start + 4);
                if (end - start < 4) start = Math.max(1, end - 4);
                const p = start + i;
                if (p > totalPages) return null;

                return (
                  <button
                    key={p}
                    className={"page-btn" + (p === page ? " active" : "")}
                    onClick={() => this.goPage(p)}
                  >
                    {p}
                  </button>
                );
              })}
              <button className="page-btn" disabled={page >= totalPages} onClick={() => this.goPage(page + 1)}>▶</button>
            </div>

            <div
              className="pagination-cnt-controls"
              style={{ display: "flex", gap: 10, alignItems: "center", position: "absolute", right: "20px" }}
            >
              <span style={{ fontSize: 14, color: "#8e8e8e" }}>페이지당</span>
              <SelectBoxV2
                id="pageSizeSelect"
                className="form-control"
                pageWrapperName="common-page-wrapper"
                width="120px"
                height="36px"
                padding="6px 30px 6px 10px"
                list={pageSizes}
                optionTexttName="text"
                optionValuetName="value"
                selectedValue={pageSize}
                placeHolder="페이지 크기"
                onClickOption={(text, value) => this.changePageSize({ target: { value } })}
                tabIndex={0}
              />
            </div>
          </div>
        </div>
      </div>
      </>
    );
  }
}